import { gql } from "apollo-boost";

// --- Feature Flag ---

export const GetPulseEnabled = gql`
  query PulseEnabled {
    me {
      id
      organization {
        id
        pulseEnabled
      }
    }
  }
`;

// --- Availability / Cooldown ---

export const GetPulseAvailability = gql`
  query PulseAvailability {
    pulseAvailability {
      lastCompletedAt
      nextAvailableAt
    }
  }
`;

// --- Mutations (Take Pulse Flow) ---

export const StartPulseTaking = gql`
  mutation StartPulse {
    startPulseTaking {
      takingId
      assessment {
        id
        displayName
        questions {
          id
          internalName
          displayName
          questionType
          questionData {
            ... on LikertQuestion {
              prompt
              likertResponses
            }
            ... on FlashWordsQuestion {
              wordLists
              wordInterval
            }
            ... on WordCallbackQuestion {
              time
              prompt
              subtext
            }
            ... on ImageThemesQuestion {
              time
              images
              subtext
            }
            ... on InformationQuestion {
              text
              image
            }
          }
        }
      }
    }
  }
`;

export const SavePulseAnswers = gql`
  mutation SavePulse($input: SavePulseAnswersInput!) {
    savePulseAnswers(input: $input) {
      success
    }
  }
`;

// --- Queries (Pulse Landing / Post Pulse) ---

export const GetLatestPulseScore = gql`
  query LatestPulseScore {
    latestPulseScore {
      pulseIndex
      factor1
      factor2
      factor3
      factor4
      calculatedAt
      takingMode
    }
  }
`;

export const GetPulseScoreHistory = gql`
  query PulseScoreHistory {
    pulseScoreHistory {
      pulseIndex
      factor1
      factor2
      factor3
      factor4
      calculatedAt
      takingMode
    }
  }
`;
